export const POSITIONS_GRID_CLASS =
	"grid min-w-[1200px] grid-cols-[1.1fr_0.9fr_0.9fr_0.9fr_0.9fr_1fr_0.9fr_0.9fr_0.7fr_1.3fr_0.9fr] gap-3";

export const OPEN_ORDERS_GRID_CLASS =
	"grid min-w-[860px] grid-cols-[1.1fr_0.7fr_1fr_1fr_1fr_1fr_0.9fr_0.8fr] gap-4";

export const TRADES_GRID_CLASS =
	"grid min-w-[860px] grid-cols-[1.1fr_0.9fr_0.7fr_1fr_1fr_1fr_0.8fr_0.9fr] gap-4";

export const BALANCES_GRID_CLASS =
	"grid min-w-[700px] grid-cols-[1fr_1.2fr_1.2fr_1fr_1fr] gap-4";

export const HIDDEN_BALANCE_COINS = new Set(["USDE", "USDT0", "USDH"]);

export const TWAP_ACTIVE_GRID_CLASS =
	"grid min-w-[980px] grid-cols-[0.8fr_0.9fr_0.9fr_0.9fr_1.15fr_0.8fr_1.35fr_0.55fr] gap-4";

export const TWAP_GRID_CLASS =
	"grid min-w-[980px] grid-cols-[1.3fr_0.8fr_0.9fr_0.9fr_0.9fr_0.8fr_0.8fr_0.9fr] gap-4";

export const FUNDING_HISTORY_GRID_CLASS =
	"grid min-w-[700px] grid-cols-[1.1fr_0.9fr_1fr_1fr_1fr] gap-4";

export const ORDER_HISTORY_GRID_CLASS =
	"grid min-w-[860px] grid-cols-[1.1fr_0.9fr_0.7fr_0.9fr_1fr_1fr_1fr] gap-4";
